import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RouterLink } from '@angular/router';

import type { Candidate } from '@recruitee/candidate-types';
import { isCandidateDataVisible } from '@recruitee/candidate-util';
import type { OfferBrief } from '@recruitee/offers-types';
import { OfferKind, OfferPath } from '@recruitee/offers-types';
import type { Placement } from '@recruitee/placements-types';
import {
  AvatarComponent,
  HeadingComponent,
  IconComponent,
  OfferStatusIndicatorComponent,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate',
  templateUrl: './candidate.component.html',
  styleUrls: ['./candidate.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarComponent,
    HeadingComponent,
    OfferStatusIndicatorComponent,
    RouterLink,
    IconComponent,
  ],
})
export class CandidateComponent {
  public candidate = input.required<Candidate>();

  public candidateClick = output<void>();
  public avatarClick = output<void>();

  public firstPlacement = computed(
    (): Placement | undefined => (this.candidate().placements || [])[0],
  );
  public urlCommands = computed(() => {
    const offer = this.firstPlacement()?.offer;
    return offer ? this.resolveCommands(offer) : [];
  });
  public isCandidateDataVisible = computed(() => isCandidateDataVisible(this.candidate()));

  private resolveCommands(offer: OfferBrief): string[] {
    const pathMap = {
      [OfferKind.Job]: OfferPath.Job,
      [OfferKind.TalentPool]: OfferPath.TalentPool,
    };
    const offerPath = pathMap[<OfferKind>offer.kind];
    return ['/', offerPath, offer.slug!, offer.kind === OfferKind.Job ? 'pipeline' : 'filters'];
  }
}
